import React from 'react';
import { Affix, Button } from 'antd';
import { FaPlus } from 'react-icons/fa';

interface FloatingButtonProps {
  onClick?: (e?: React.MouseEvent) => void;
}

export const FloatingButton: React.FC<FloatingButtonProps> = ({ onClick }) => {
  return (
    <Affix offsetBottom={20}>
      <div className="floating-button">
        <Button shape="circle" size="large" onClick={onClick}>
          <FaPlus size={14} />
        </Button>
      </div>
    </Affix>
  );
};
